import React__default, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import PropTypes from 'prop-types';
function ProgressBar(_ref) {
  let {
    isComplete,
    onComplete
  } = _ref;
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let timer;
    if (isComplete) {
      setProgress(100);
      setTimeout(() => {
        onComplete === null || onComplete === void 0 || onComplete();
      }, 500);
    } else {
      timer = setInterval(() => {
        setProgress(oldProgress => {
          if (oldProgress >= 99) {
            return oldProgress; // 卡在 99%
          }
          const diff = Math.random() * 10;
          return Math.min(oldProgress + diff, 99); // 增加进度，不超过 99%
        });
      }, 500);
    }
    return () => timer && clearInterval(timer);
  }, [isComplete]);
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(LinearProgress, {
    variant: "determinate",
    value: progress,
    sx: {
      height: '6px',
      // 高度 6px
      borderRadius: '4px',
      // 圆角
      backgroundColor: '#E6E6E6',
      // 背景色
      '& .MuiLinearProgress-bar': {
        background: 'linear-gradient(270deg, #CF8BF3 0%, #B2B5FB 50%, #94B0F7 95%)',
        // 渐变色
        borderRadius: '4px' // 进度条圆角
      }
    }
  })), /*#__PURE__*/React__default.createElement(Box, {
    color: "#222",
    fontSize: 12,
    fontWeight: 300,
    ml: "8px",
    flexShrink: 0
  }, progress.toFixed(0), "%"));
}
ProgressBar.propTypes = {
  isComplete: PropTypes.bool,
  onComplete: PropTypes.func
};
ProgressBar.defaultProps = {
  isComplete: false,
  onComplete: null
};
export { ProgressBar as default };